import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponent } from './shared-component/header/header.component';
import { LoginComponent } from './authuntication/login/login.component';
import { ModuleModule } from './shared/module/module.module';
import { HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CoreModule } from './core/core.module';
import { SecondHeaderComponent } from './shared-component/second-header/second-header.component';
import { SmallHeaderComponent } from './shared-component/small-header/small-header.component';
import { StatusChangeComponent } from './shared-component/components/status-change/status-change.component';
import { MaterialModule } from './shared/module/materials.module';
import { SearchPipe } from './shared/pipes/search.pipe';
import { DeleteComponent } from './shared-component/components/delete/delete.component';
import { ErrorPaymentComponent } from './static-pages/payment/error-payment/error-payment.component';
import { SuccessPaymentComponent } from './static-pages/payment/success-payment/success-payment.component';
import { PublicBookingComponent } from './static-pages/booking/public-booking/public-booking.component';
import { SuccessMessageComponent } from './static-pages/booking/success-message/success-message.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LoginComponent,
    SearchPipe,
    StatusChangeComponent,
    SecondHeaderComponent,
    SmallHeaderComponent,
    DeleteComponent,
    ErrorPaymentComponent,
    SuccessPaymentComponent,
    PublicBookingComponent,
    SuccessMessageComponent
  ],
  imports: [
    MaterialModule,
    CoreModule,
    BrowserModule,
    ModuleModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    CoreModule,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
